import React, { useContext, useEffect, useState } from 'react';
import AdWrapper from '../AdTechConfig';
import { BUS_SEO_AD_CONTEXT_ID } from '../constants/adsConfig';
import { ifAdsPresent } from '../utils/adsUtils';
import { Context } from '../AppContext';

type AdsConfig = {
  position: string;
  class: string;
  style: any;
};
type AdsComponentProp = {
  template: string;
  placedAt: string;
  isMobileDevice: boolean;
  desktopAdConfig: AdsConfig;
  mobileAdConfig: AdsConfig;
};
const AdsComponent = ({
  template,
  placedAt,
  isMobileDevice,
  desktopAdConfig,
  mobileAdConfig
}: AdsComponentProp) => {
  const { trackTemplateEvent } = useContext(Context);
  const [initLoad, setInitLoad] = useState<boolean>(false);

  useEffect(() => {
    if (!initLoad) setInitLoad(true);
  }, []);

  const pageLoadedInBrowser = () => {
    return initLoad && typeof window != 'undefined';
  };

  const isCrawler = () => {
    if (typeof navigator !== 'undefined') {
      const botPattern =
        '(googlebot/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';
      const regex = new RegExp(botPattern, 'i');
      const userAgent = navigator.userAgent;
      return regex.test(userAgent);
    }
    return false;
  };

  return (
    <div className="adsComponentContainer">
      {!isCrawler()
        ? isMobileDevice
          ? (() =>
              pageLoadedInBrowser() &&
              mobileAdConfig.position &&
              mobileAdConfig.position === placedAt ? (
                <div className={'makeFlex perfectCenter'}>
                  <div
                    style={mobileAdConfig.style}
                    className={mobileAdConfig.class}
                    onClick={() => {
                      if (ifAdsPresent())
                        trackTemplateEvent(
                          `Mob_Bus_SEO_${template}_Template_Ad_Clicked`
                        );
                    }}
                  >
                    <AdWrapper uuid={BUS_SEO_AD_CONTEXT_ID} />
                  </div>
                </div>
              ) : null)()
          : (() =>
              pageLoadedInBrowser() &&
              desktopAdConfig.position &&
              desktopAdConfig.position === placedAt ? (
                <div className={'makeFlex perfectCenter'}>
                  <div
                    style={desktopAdConfig.style}
                    className={desktopAdConfig.class}
                    onClick={() => {
                      if (ifAdsPresent())
                        trackTemplateEvent(
                          `Desktop_Bus_SEO_${template}_Template_Ad_Clicked`
                        );
                    }}
                  >
                    <AdWrapper uuid={BUS_SEO_AD_CONTEXT_ID} />
                  </div>
                </div>
              ) : null)()
        : null}
    </div>
  );
};

export default AdsComponent;
